import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "shop-subscriptions",
  "use": "shop-subscriptions-usage",
  "viewBox": "0 0 40 40",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 40 40\" fill=\"none\" id=\"shop-subscriptions\"><path d=\"M12 10h14l4 4v16H12V10z\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\" /><path d=\"M26 10v4h4\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linejoin=\"round\" /><path d=\"M16 18h10m-10 5h10m-10 5h6\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol